const tableData = [
    {
        srNo: 1,
        name: 'JYOTSNA HUI',
        position: 'PRESIDENT'
    },
    {
        srNo: 2,
        name: 'SHIVAM PANDEY',
        position: 'GENERAL SECRETARY'
    },
    {
        srNo: 3,
        name: 'KARTIK THAKKER',
        position: 'VICE PRESIDENT'
    },
    {
        srNo: 4,
        name: 'SAURAV KUMAR NISHANT',
        position: 'ASSISTANT SECRETARY'
    },
    {
        srNo: 5,
        name: 'TEERATH KUMAR',
        position: 'TREASURER'
    },
    {
        srNo: 6,
        name: 'MIHIR GUPTA',
        position: 'PUBLIC RELATIONS OFFICER'
    },
    {
        srNo: 7,
        name: 'CHINMAY KRISHNA',
        position: 'SCHOOL DEVELOPMENT OFFICER'
    },
    {
        srNo: 8,
        name: 'YASH RAJ GUPTA',
        position: 'CHIEF FUNDRAISING OFFICER'
    },
    {
        srNo: 9,
        name: 'ABHISHEK JAIN',
        position: 'HUMAN RESOURCE MANAGER'
    },
    {
        srNo: 10,
        name: 'GAURAV SINGH',
        position: ' EXECUTIVE OFFICER [RS]'
    },
    {
        srNo: 11,
        name: 'PRERIT JAIN',
        position: 'CHIEF EXECUTIVE OFFICER [LiGHT]'
    },
 
    // Add more data as needed
];

export default tableData;